<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="title">
			<el-form class="form-inlines u-f  u-jsb " :inline="true">
				<div>
					<!-- <el-form-item label="模糊搜索">
						<el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item> -->
				</div>
				<div>
					<el-form-item>
						<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
						</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
				<el-table-column prop="title" label="训练标题" show-overfl ow-tooltip> </el-table-column>
				<el-table-column prop="tag" label="训练标签" show-overfl ow-tooltip> </el-table-column>
				<el-table-column prop="text" label="训练简介" show-overfl ow-tooltip> </el-table-column>
				<el-table-column prop="day" label="完成天数" show-overflow-tooltip width="50"> </el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
						</el-button>
						<el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 设置 -->
		<el-dialog title="训练设置" width="60%" :visible.sync="dialoged" @close='closedialo' top="80px" center
			class="dialogs">
			<el-divider></el-divider>

			<div class="dialog-ibox-content">
				<el-form ref="forms" :model="forms" :rules="rules" label-width="140px" class="demo-ruleForm">
					<el-tabs type="border-card" v-model="activeName">
						<el-tab-pane label="基本信息" name="first">
							<div>
								<el-form-item label="训练标题" prop="xl_tit">
									<el-input size="small" v-model="forms.xl_tit" placeholder="请输入训练标题"></el-input>
								</el-form-item>
							</div>
							<el-form-item label="训练标签" prop="xl_tit2">
								<el-input size="small" v-model="forms.xl_tit2" type="text" placeholder="请输入训练标签">
								</el-input>
							</el-form-item>
							<el-form-item label="简介" prop="xl_jj">
								<el-input size="small" v-model="forms.xl_jj" type="textarea" :rows="3"
									placeholder="请输入训练简介">
								</el-input>
							</el-form-item>
							<el-form-item label="列表图标" required>
								<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
									:headers="{ token:$store.state.user.token }"
									:data="{ image_class_id:'72',file_type:'1' }" :file-list="forms.lb_mapList"
									:on-success="uploadSuccesslb" :on-remove="uploadRmovelb" :limit="1"
									list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
							<el-form-item label="背景图片" required>
								<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
									:headers="{ token:$store.state.user.token }"
									:data="{ image_class_id:'72',file_type:'1',verification:1,fileS:2,fileH:310,fileW:600 }"
									:file-list="forms.bj_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
									:limit="1" list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
							<el-form-item label="完成天数" prop="xl_day">
								<el-input size="small" v-model="forms.xl_day" type="number" min="1">
								</el-input>
							</el-form-item>
							<div class="u-f u-ajc">
								<el-button type="primary" @click="nextstep">下一步</el-button>
							</div>
						</el-tab-pane>
						<el-tab-pane label="阶段配置" name="second">
							<div v-for="(jd,index) in forms.jd_options" :key="index" class="yd_sty">
								<el-form-item :label="'第'+(index+1)+'阶段名称'" required>
									<el-input size="small" v-model="jd.title"></el-input>
								</el-form-item>
								<el-form-item :label="'第'+(index+1)+'阶段内容'" required>
									<tinymce ref="editor" v-model="jd.content"
										toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
								</el-form-item>
								<div>设置要点：</div>
								<div v-for="(yd,ind) in jd.yd_options" :key="ind" class="yd_sty">
									<el-form-item :label="'要点'+(ind+1)+'标题'" >
										<el-input size="small" v-model="yd.yd_tit"></el-input>
									</el-form-item>
									<el-form-item :label="'要点'+(ind+1)+'内容'" >
										<el-input size="small" v-model="yd.yd_con"></el-input>
									</el-form-item>
									<el-form-item :label="'要点'+(ind+1)+'链接'" >
										<el-input size="small" v-model="yd.yd_link"></el-input>
									</el-form-item>
									<el-form-item v-if="ind!=0" style="margin-top:15px;text-align:right;">
										<el-button icon="el-icon-delete" size="mini" @click="delyd(index,yd)" type="danger">删除要点
										</el-button>
									</el-form-item>
								</div>
								<div class="addpro">
									<el-form-item style="margin-top:15px">
										<el-button size="small" icon="el-icon-plus" type='info' @click="addyd(index)">添加要点</el-button>
									</el-form-item>
								</div>
								<el-form-item v-if="index!=0" style="margin-top:15px;text-align:right;">
									<el-button icon="el-icon-delete" size="mini" @click="deljd(jd)" type="danger">删除阶段
									</el-button>
								</el-form-item>
							</div>
							<div class="addpro">
								<el-form-item style="margin-top:15px">
									<el-button size="small" icon="el-icon-plus" @click="addjd">添加阶段</el-button>
								</el-form-item>
							</div>
							<div class="u-f u-ajc">
								<el-button type="primary" @click="nextstep">下一步</el-button>
							</div>
						</el-tab-pane>
						<el-tab-pane label="选择话题" name="third">
							<div>话题选择：</div>
							<el-form-item label="话题" required>
								<el-select v-model="forms.ht_value" placeholder="请选择">
									<el-option v-for="item in ht_options" :key="item.id" :label="item.title"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							
							<div class="u-f u-ajc">
								<el-button type="primary" @click="nextstep">下一步</el-button>
							</div>
						</el-tab-pane>
						<el-tab-pane label="商品选择" name="fourth">
							<el-form-item label="选择推荐商品" required>
								<div class="u-f">
									<div style="width:50%">
										<el-table :data="goodsTableData" border v-loading="shoploading" height="430"
											ref="configurationTables" @selection-change="handleSelectionChange"
											:row-key="getRowKeys">
											<el-table-column type="selection" width="55" :reserve-selection="true"
												:selectable="selectable" />
											<el-table-column prop="title" label="商品图片" show-overfl ow-tooltip>
												<template slot-scope="scope">
													<el-image style="width: 100px; height: 100px" :src="scope.row.cover"
														:preview-src-list="[scope.row.cover]">
													</el-image>
												</template>
											</el-table-column>
											<el-table-column prop="title" label="商品名" show-overflow-tooltip>

											</el-table-column>
										</el-table>
										<div class="u-f u-ac u-jsb ft_mr">
											<div></div>
											<div>
												<el-pagination @size-change="userhandleSizeChange"
													@current-change="userhandleCurrentChange"
													:current-page="usercurrentPage" :page-sizes="[10, 20, 30, 40]"
													:page-size="userpagesize"
													layout="total, sizes, prev, pager, next, jumper"
													:total="goodscount">
												</el-pagination>
											</div>
										</div>
									</div>
									<div style="width:50%;margin-left:10px">
										<el-table :data="selectGoods" border v-loading="shoploading" height="430"
											ref="configurationTable">
											<el-table-column prop="title" label="商品图片" show-overfl ow-tooltip>
												<template slot-scope="scope">
													<el-image style="width: 100px; height: 100px" :src="scope.row.cover"
														:preview-src-list="[scope.row.cover]">
													</el-image>
												</template>
											</el-table-column>
											<el-table-column prop="title" label="商品名" show-overflow-tooltip>
											</el-table-column>
											<el-table-column label="操作" width="80">
												<template slot-scope="scope">
													<el-button size="mini" type="danger"
														@click="goodsDel(scope.$index, scope.row)">删除
													</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
							</el-form-item>
							<div class="u-f u-ajc">
								<el-button type="primary" @click="nextstep">下一步</el-button>
							</div>
						</el-tab-pane>
						<el-tab-pane label="推荐内容" name="fifth">
							<div v-for="(tj,index) in forms.tjnr_options" :key="index" class="yd_sty">
								<el-form-item :label="'内容'+(index+1)+'标题'" required>
									<el-input size="small" v-model="tj.tj_tit"></el-input>
								</el-form-item>
								<el-form-item :label="'内容'+(index+1)+'链接'" required>
									<el-input size="small" v-model="tj.tj_link"></el-input>
								</el-form-item>
								<el-form-item v-if="index!=0" style="margin-top:15px;text-align:right;">
									<el-button icon="el-icon-plus" size="mini" @click="deltjnr(tj)" type="danger">删除
									</el-button>
								</el-form-item>
							</div>
							<div class="addpro">
								<el-form-item style="margin-top:15px">
									<el-button size="small" icon="el-icon-plus" @click="addyjnr">添加</el-button>
								</el-form-item>
							</div>

							<div class="u-f u-ajc">
								<el-button type="primary" :loading='submiting' :disabled='submiting'
									@click="submited('forms')" size="small">确 定</el-button>
								<el-button @click="dialoged = false" size="small">取 消</el-button>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-form>
			</div>
			<el-divider></el-divider>

		</el-dialog>

	</div>
</template>


<script>
	import tinymce from '@/components/common/tinymce.vue';
	import {
		mapState
	} from 'vuex'
	export default {
		components: {
			tinymce
		},
		data() {
			return {
				sendradio: 2,
				lookdialoged: false,
				shoploading: false,
				looktableData: [],
				lookcount: 0,
				lookcurrentPage: 1,
				lookpagesize: 10,
				luId: '',
				resource_id: 'p_5fdb0346e4b0231ba88d4839',
				resource_type: '4',
				dialog: false,
				titles: '',
				loading: false,
				tableData: [],
				goodsTableData: [],
				seleteUserTableData: [],
				currentPage: 1,
				pagesize: 10,
				usercurrentPage: 1,
				userpagesize: 10,
				goodscount: 0,
				userkeyword: '',
				count: 0,
				heights: null,

				// 
				eid: '',
				dialoged: false,
				lb_value: '',
				lb_options: [{
					id: 1,
					name: '普通用户'
				}, {
					id: 2,
					name: '医生'
				}],
				forms: {
					xl_day: '',
					xl_jj: '',
					xl_tit2: '',
					xl_tit: '',
					ht_value: '',
					jd_options: [{
						title: '',
						content: '',
						yd_options: [{
							yd_tit: "",
							yd_con: '',
							yd_link: ''
						}],
					}],
					yd_options: [{
						yd_tit: "",
						yd_con: '',
						yd_link: ''
					}],
					tjnr_options: [{
						tj_tit: '',
						tj_link: '',
					}],
					bj_mapList: [],
					lb_mapList: [],
				},
				rules: {
					xl_tit: [{
						required: true,
						message: '请填写训练标题',
						trigger: 'blur'
					}],
					xl_tit2: [{
						required: true,
						message: '请填写训练标签',
						trigger: 'blur'
					}],
					xl_jj: [{
						required: true,
						message: '请填写训练简介',
						trigger: 'blur'
					}],
					xl_day: [{
						required: true,
						message: '请填写训练完成天数',
						trigger: 'blur'
					}],
				},
				listItem: [],
				arrxq: '',
				selectGoods: [],
				mapListed: [],
				lbIcon: [],
				limitNum: 3,
				activeName: 'first',
				yd_options: [{
					yd_tit: "",
					yd_con: '',
					yd_link: ''
				}],
				ht_options: [],
				jd_options: [{
					title: '',
					content: ''
				}],
				jd_optionsed: {
					title: [{
						required: true,
						message: '标题不能为空！',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '*必填',
						trigger: 'blur'
					}, ],
				},
				submiting: false,
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			that.begin()
			this.getht()
			that.searchgoods()
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				var title = that.$refs.title.offsetHeight
				that.heights = window.innerHeight - title - 200 + 'px'
				window.onresize = () => {
					var title = that.$refs.title.offsetHeight
					that.heights = window.innerHeight - title - 200 + 'px'
				}
			},
			getht() {
				axios.get(`admin/topicclass/7/topic/1?userId=${this.user.id}`, {
						token: true
					})
					.then(response => {
						this.ht_options = response.data.data.list
						this.count = response.data.data.count
					})
					.catch(error => {})
			},
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 10
				that.search()
			},
			search() {
				let that = this
				that.loading = true
				axios
					.post("/admin/pc/healthSelfTest/Train/index", {
						page: that.currentPage,
						limit: that.pagesize,
					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.data
						that.count = response.data.data.count

					})
					.catch(error => {})
			},

			searchgoods() {
				let that = this
				let urls = `/admin/goods/${this.usercurrentPage}?limit=${this.userpagesize}&tab=all`
				axios
					.get(urls, {
						token: true
					})
					.then(res => {
						this.goodsTableData = res.data.data.list
						this.goodscount = res.data.data.totalCount
					})
					.catch(error => {})
			},

			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},


			getRowKeys(row) {
				return row.id; // id为列表数据的唯一标识
			},
			userhandleSizeChange(val) {
				let that = this
				that.userpagesize = val;
				that.searchgoods()
			},
			userhandleCurrentChange(val) {
				let that = this
				that.usercurrentPage = val;
				that.searchgoods()
			},
			// 新增
			add() {
				let that = this
				that.dialoged = true
				that.eid = ''
				this.clearform()
				that.searchgoods()

			},
			clearform() {
				this.forms.xl_day = ''
				this.forms.xl_jj = ''
				this.forms.xl_tit2 = ''
				this.forms.xl_tit = ''
				this.forms.ht_value = ''
				this.forms.jd_options = [{
					title: '',
					content: '',
					yd_options: [{
							yd_tit: "",
							yd_con: '',
							yd_link: ''
						}],
				}]
				this.forms.yd_options = [{
					yd_tit: "",
					yd_con: '',
					yd_link: ''
				}]
				this.forms.tjnr_options = [{
					tj_tit: "",
					tj_link: ''
				}]
				this.forms.bj_mapList = []
				this.forms.lb_mapList = []
				this.lbIcon = []
				this.mapListed = []
			},

			// 设置
			submited(formName) {
				let that = this
				if (this.mapListed.length == 0) {
					this.$message({
						message: '未上传背景图片',
						type: 'warning'
					});
					return false
				}
				if (this.lbIcon.length == 0) {
					this.$message({
						message: '未上传列表图片',
						type: 'warning'
					});
					return false
				}
				let jdnull = false
				this.forms.jd_options.forEach(ele => {
					if (ele.title == '' || ele.content == '') {
						jdnull = true
						return false
					}
				})
				if (jdnull) {
					this.$message({
						message: '阶段信息请填写完整',
						type: 'warning'
					});
					return false
				}
				if (this.forms.ht_value == '') {
					this.$message({
						message: '请选择话题',
						type: 'warning'
					});
					return false
				}
				// let ydnull = false
				// this.forms.jd_options.forEach(element=>{
				// 	element.yd_options.forEach(ele => {
				// 	if (ele.yd_tit == '' || ele.yd_con == '' || ele.yd_link == '') {
				// 		ydnull = true
				// 		return false
				// 	}
				// })
				// })
				
				// if (ydnull) {
				// 	this.$message({
				// 		message: '有阶段要点信息为空',
				// 		type: 'warning'
				// 	});
				// 	return false
				// }
				if (this.selectGoods.length == 0) {
					this.$message({
						message: '未选择任何商品',
						type: 'warning'
					});
					return false
				}
				let tjnrnull = false
				this.forms.tjnr_options.forEach(ele => {
					if (ele.tj_tit == '' || ele.tj_link == '') {
						tjnrnull = true
						return false
					}
				})
				if (tjnrnull) {
					this.$message({
						message: '推荐内容请填写完整',
						type: 'warning'
					});
					return false
				}


				let goodsids = []
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.selectGoods.forEach(ele => {
							goodsids.push(ele.id)
						});
						let params = {
							id: this.eid,
							title: this.forms.xl_tit,
							tag: this.forms.xl_tit2,
							text: this.forms.xl_jj,
							day: this.forms.xl_day,
							stage_list: JSON.stringify(this.forms.jd_options),
							points: JSON.stringify(this.forms.yd_options),
							topic_id: this.forms.ht_value,
							goods: goodsids.join(','),
							bgimg: this.mapListed ? this.mapListed[0].url : '',
							icon: this.lbIcon ? this.lbIcon[0].url : '',
							recommend: JSON.stringify(this.forms.tjnr_options)
						}
						this.submiting = true
						axios
							.post("/admin/pc/healthSelfTest/Train/edit", params, {
								token: true
							})
							.then(response => {

								if (response.data.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
									that.begin()
									that.dialoged = false
									that.submiting = false
								} else {
									that.submiting = false
									this.$message({
										message: response.data.msg,
										type: 'warning'
									});
								}

							})
							.catch(error => {
								that.submiting = false
							})
					} else {
						this.$message({
							message: '有必填信息遗漏',
							type: 'warning'
						});
						return false;
					}
				});
			},
			async handleEdit(index, d) {
				let that = this
				var  row = await this.ajax('healthSelfTest/Train/info', {
					id: d.id
				})
				let res=row.data[1]
				that.dialoged = true
				that.eid = res.id
				this.forms.xl_day = res.day
				this.forms.xl_jj = res.text
				this.forms.xl_tit2 = res.tag
				this.forms.xl_tit = res.title
				this.forms.ht_value = res.topic_id
				this.forms.jd_options = res.stage_list
				this.forms.yd_options = res.points
				this.forms.tjnr_options = res.recommend

				this.forms.bj_mapList = [{
					url: res.bgimg ? res.bgimg : ''
				}]
				this.forms.lb_mapList = [{
					url: res.icon ? res.icon : ''
				}]
				this.lbIcon = [{
					url: res.icon ? res.icon : ''
				}]
				this.mapListed = [{
					url: res.bgimg ? res.bgimg : ''
				}]
				that.searchgoods()

				// this.$nextTick(() => {
				// 	this.$refs.configurationTables.clearSelection();
				// })

			},
			handleDel(index, row) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios
						.post("/admin/pc/healthSelfTest/Train/del", {
							id: row.id
						}, {
							token: true
						})
						.then(response => {
							if (response.data.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.begin()
							}

						})
						.catch(error => {})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},

			selectable(row) {
				let index = this.selectGoods.findIndex(v => v.id === row.id)
				if (this.selectGoods.length > this.limitNum) {
					if (index !== -1) {
						return true
					} else {
						return false
					}
				} else {
					return true
				}
			},
			closedialo() {
				this.userkeyword = ''
				this.selectGoods = []
				this.$nextTick(() => {
					this.$refs.configurationTables.clearSelection();

				})
			},
			// 回调表格选择的数据
			handleSelectionChange(list) {
				if (list.length > this.limitNum) {
					this.limitFn(list)
					this.$message({
						type: 'info',
						message: '最多选择3个商品'
					});
					return
				}
				this.selectGoods = list;

			},
			// 限制数量方法
			limitFn(list) {
				this.$refs.configurationTables.clearSelection();
				for (let i = 0; i < this.limitNum; i++) {
					this.$refs.configurationTables.toggleRowSelection(list[i]);
				}
			},
			goodsDel(index, row) {
				let delindex = this.selectGoods.indexOf(row)
				this.selectGoods.splice(delindex, 1)
				this.$refs.configurationTables.toggleRowSelection(row);
			},
			nextstep() {
				if (this.activeName == 'first') {
					this.activeName = 'second'
				} else if (this.activeName == 'second') {
					this.activeName = 'third'
				} else if (this.activeName == 'third') {
					this.activeName = 'fourth'
				} else {
					this.activeName = 'fifth'
				}
			},
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				var index = this.mapListed.findIndex(item => item.id == file.id)
				this.mapListed.splice(index, 1)
			},
			uploadSuccesslb(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.lbIcon.push(response.data)
			},
			uploadRmovelb(file, fileList) {
				var index = this.lbIcon.findIndex(item => item.id == file.id)
				this.lbIcon.splice(index, 1)
			},
			addyd(index) {
				this.forms.jd_options[index].yd_options.push({
					yd_tit: "",
					yd_con: '',
					yd_link: ''
				})
			},
			delyd(ind,item) {
				this.$confirm('此操作将删除该要点,内容也随之清除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var index = this.forms.jd_options[ind].yd_options.indexOf(item)
					if (index !== -1) {
						this.forms.jd_options[ind].yd_options.splice(index, 1)
					}
				}).catch(() => {

				});

			},
			addyjnr() {
				this.forms.tjnr_options.push({
					tj_tit: '',
					tj_link: '',
				})
			},
			deltjnr(data) {
				this.$confirm('此操作将删除该推荐内容, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var index = this.forms.tjnr_options.indexOf(data)
					if (index !== -1) {
						this.forms.tjnr_options.splice(index, 1)
					}
				}).catch(() => {

				});
			},
			addjd() {
				this.forms.jd_options.push({
					title: '',
					content: '',
					yd_options: [{
							yd_tit: "",
							yd_con: '',
							yd_link: ''
						}],
				})
			},
			deljd(jd) {
				this.$confirm('此操作将删除该阶段,内容也随之清除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var index = this.forms.jd_options.indexOf(jd)
					if (index !== -1) {
						this.forms.jd_options.splice(index, 1)
					}
				}).catch(() => {

				});
			},

		},

	};
</script>


<style scoped>
	.pd {
		padding: 0 10px
	}

	.editors {
		height: 300px;

	}

	.editors>>>.tox-tinymce {
		height: 300px !important;
	}

	.xq {
		color: rgb(0, 147, 206);
		cursor: pointer;
	}

	.yd_sty {
		border-bottom: 1px solid rgb(219, 219, 219);
		padding: 10px 0;
	}

	.el-form-item {
		margin-bottom: 0;
	}
</style>